import { Checkbox } from 'semantic-ui-react';
import config from '@plone/volto/registry';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import { NEWS_PORTAL_TYPES } from 'volto-ministerio-publico-federal/constants';
import {
  DECLARACAO_FIELD,
  DECLARACAO_TEXTO,
  exigeDeclaracaoDados,
} from 'volto-ministerio-publico-federal/helpers/Noticias/declaracao';

interface PrivacidadeDadosWidgetProps {
  id: string;
  value?: unknown;
  isDisabled?: boolean;
  formData?: Record<string, unknown> & { '@type'?: string };
  onChange: (id: string, value?: unknown) => void;
  [key: string]: unknown;
}

/**
 * Campo `privacidade_dados` ("Classificação dos dados"). Renderiza o select
 * padrão do Volto (`widgets.choices`) e, nas notícias com dados pessoais ou
 * sensíveis, o checkbox de declaração logo abaixo, alinhado à coluna do campo.
 * O Bool `declaracao_dados_protegidos` é oculto no schema (`mode: hidden`) e
 * só é editado aqui.
 *
 * Voltar a "Público" (ou limpar o select) zera a declaração, para não deixar
 * uma ciência "órfã" gravada; o backend normaliza do mesmo jeito.
 */
const PrivacidadeDadosWidget = (props: PrivacidadeDadosWidgetProps) => {
  const { isDisabled, formData, onChange } = props;
  const SelectWidget = config.widgets.choices;
  const isNews = NEWS_PORTAL_TYPES.includes(formData?.['@type'] ?? '');
  const declarado = formData?.[DECLARACAO_FIELD] === true;
  const mostrarDeclaracao = isNews && exigeDeclaracaoDados(props.value);
  const checkboxId = `field-${DECLARACAO_FIELD}`;

  if (!isNews) return <SelectWidget {...props} />;

  return (
    <>
      <SelectWidget
        {...props}
        onChange={(fieldId: string, nextValue?: unknown) => {
          onChange(fieldId, nextValue);
          if (!exigeDeclaracaoDados(nextValue) && declarado) {
            onChange(DECLARACAO_FIELD, false);
          }
        }}
      />
      {mostrarDeclaracao && (
        <FormFieldWrapper
          id={DECLARACAO_FIELD}
          title=""
          className="mpf-declaracao-dados"
          noForInFieldLabel
        >
          <Checkbox
            id={checkboxId}
            name={checkboxId}
            checked={declarado}
            disabled={isDisabled}
            onChange={(_event, { checked }) =>
              onChange(DECLARACAO_FIELD, checked === true)
            }
            label={<label htmlFor={checkboxId}>{DECLARACAO_TEXTO}</label>}
          />
          {!declarado && (
            <p className="mpf-declaracao-dados__aviso text-sm text-red-600">
              Obrigatória: marque a declaração para poder salvar.
            </p>
          )}
        </FormFieldWrapper>
      )}
    </>
  );
};

export default PrivacidadeDadosWidget;
